import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";

// Animation variants (consistent with About & Vision)
const sectionVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

const cardsWrapperVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.18 },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 35 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const WhyChooseUs = () => {
  const features = [
    {
      title: "Fast & Reliable Development",
      desc: "We focus on efficient, lightweight builds using React + Bootstrap — giving you fast-loading, clean, and stable websites.",
    },
    {
      title: "Clear, Simple & Modern Design",
      desc: "No clutter, no complexity. Just clean layouts designed to help your visitors understand quickly and take action effortlessly.",
    },
    {
      title: "Affordable & Flexible Packages",
      desc: "Just like a sari-sari store, you get only what you actually need — nothing overpriced, nothing excessive.",
    },
    {
      title: "Built for Real People",
      desc: "We design with the everyday Filipino user in mind. Simple flows, easy navigation, and mobile-first experience.",
    },
    {
      title: "Guided, Not Confusing",
      desc: "We explain every step and guide you through the process. No technical jargon — just clear communication.",
    },
    {
      title: "Long-term Support",
      desc: "We don’t just build your site. We help you maintain it, update it, and grow it as your business evolves.",
    },
  ];

  return (
    <motion.section
      id="why-us"
      style={{
        paddingTop: "90px",
        paddingBottom: "60px",
        background: "linear-gradient(180deg, #e6f7f7, #f9fdfd)",
      }}
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <Container style={{ maxWidth: "1100px" }}>
        
        {/* Header */}
        <Row className="mb-4">
          <Col>
            <motion.h1
              style={{
                fontSize: "clamp(2.3rem, 4vw, 2.9rem)",
                fontWeight: "800",
                color: "#054E48",
                textAlign: "center",
                marginBottom: "16px",
              }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Why Choose Us
            </motion.h1>

            <motion.p
              style={{
                fontSize: "clamp(1.1rem, 2.3vw, 1.35rem)",
                lineHeight: "2rem",
                color: "rgba(0,0,0,0.75)",
                textAlign: "center",
                maxWidth: "840px",
                margin: "0 auto",
              }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              With Sari-sari Web Development, you get a practical, honest, and highly efficient
              approach to building websites — perfect for startups, small businesses, freelancers,
              and modern local brands.
            </motion.p>
          </Col>
        </Row>

        {/* Feature cards */}
        <motion.div
          variants={cardsWrapperVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <Row className="gy-4 mt-3">
            {features.map((item, index) => (
              <Col xs={12} md={6} lg={4} key={index}>
                <motion.div
                  variants={cardVariants}
                  whileHover={{
                    y: -6,
                    boxShadow: "0 14px 30px rgba(0,0,0,0.15)",
                  }}
                  transition={{ type: "spring", stiffness: 220, damping: 18 }}
                  style={{
                    height: "100%",
                    background: index % 2 === 0 ? "#ffffff" : "rgba(21, 207, 192, 0.12)",
                    padding: "24px 26px",
                    borderRadius: "16px",
                    border:
                      index % 2 === 0
                        ? "1px solid rgba(0,0,0,0.06)"
                        : "1px solid rgba(5, 78, 72, 0.25)",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.05)",
                    cursor: "default",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "clamp(1.35rem, 3vw, 1.7rem)",
                      fontWeight: "700",
                      color: "#054E48",
                      marginBottom: "10px",
                    }}
                  >
                    {item.title}
                  </h3>

                  <p
                    style={{
                      fontSize: "clamp(1.05rem, 2vw, 1.2rem)",
                      color: "rgba(0,0,0,0.75)",
                      lineHeight: "1.85rem",
                    }}
                  >
                    {item.desc}
                  </p>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </motion.section>
  );
};

export default WhyChooseUs;
